import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { RecipeEditorComponent } from '../../../recipe-editor/recipe-editor.component';

@Component({
  selector: 'delete-recipe',
  templateUrl: './delete-recipe.component.html',
  styleUrls: ['./delete-recipe.component.scss'],
  standalone: false,
})
export class DeleteRecipeComponent implements OnInit {
  constructor(public dialogRef: MatDialogRef<RecipeEditorComponent>) {}

  ngOnInit(): void {}

  onClose() {
    this.dialogRef.close(false);
  }

  onDelete() {
    this.dialogRef.close(true);
  }
}
